export default __webpack_public_path__ + "354024659fd141bb9b9f9012936ac1d1.jpg";